<template>
    <x-page title="Billing">
        <x-table :headers="['#', 'Status', 'Total']" :is-loading="isLoading">
            <tr v-for="resource in resources" :key="resource.id">
                <td class="nowrap">
                    <router-link
                        v-if="canEdit"
                        :to="`/admin/translation-billings/${resource.id}/edit`"
                        title="Klik untuk update"
                    >
                        #{{ resource.id }}
                    </router-link>
                    <router-link
                        v-else
                        :to="`/admin/translation-billings/${resource.id}`"
                        title="Klik untuk lihat detail"
                    >
                        #{{ resource.id }}
                    </router-link>
                </td>
                <td>
                    {{ resource.status }}
                </td>
                <td>
                    {{ resource.grand_total | price }}
                </td>
            </tr>
        </x-table>

        <x-pagination
            v-if="shouldRenderPagination"
            :pagination="meta"
            :query="$route.query"
        />
    </x-page>
</template>

<script>
import XCreateButton from "../../components/XCreateButton.vue";
import XQuickDeleteButton from "../../components/XQuickDeleteButton.vue";
import XFormGroup from "../../components/XFormGroup.vue";
import XPage from "../../components/XPage.vue";
import XPagination from "../../components/XPagination.vue";
import XTable from "../../components/XTable.vue";
import {
    getLoggedUser,
    handleGeneralXhrError,
    isTranslationBillingAdmin,
} from "../../helpers";
import FilterableMixin from "../../mixins/FilterableMixin";
import PaginationMixin from "../../mixins/PaginationMixin";
import PermissionMixin from "../../mixins/PermissionMixin";
import XQuickActionButton from "../../components/XQuickActionButton.vue";
import XQuickEditButton from "../../components/XQuickEditButton.vue";

const defaultFilters = {};

export default {
    beforeRouteUpdate(to, from, next) {
        this.fetchResources(to);
        next();
    },
    components: {
        XCreateButton,
        XTable,
        XQuickDeleteButton,
        XPage,
        XFormGroup,
        XPagination,
        XQuickActionButton,
        XQuickEditButton,
    },
    computed: {
        canEdit() {
            return isTranslationBillingAdmin(getLoggedUser());
        },
    },
    created() {
        this.preselectFilters(defaultFilters);
        this.handleFilter().catch(() => {
            this.fetchResources();
        });
    },
    data() {
        return {
            filters: { ...defaultFilters },
            isLoading: false,
            resources: [],
        };
    },
    methods: {
        fetchResources(route = this.$route) {
            this.isLoading = true;
            const request = axios
                .get("/api/translation-billings", {
                    params: { ...route.query, without_global_scopes: 1 },
                })
                .then((response) => {
                    this.$set(this, "resources", response.data.data);
                    this.setMeta(response);
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
        handleFilter() {
            return this.$router.push({
                path: this.$route.path,
                query: _.pickBy({
                    ...this.filters,
                    page: 1,
                }),
            });
        },
        resetFilter() {
            this.filters = { ...defaultFilters };
            this.handleFilter();
        },
    },
    mixins: [FilterableMixin, PaginationMixin, PermissionMixin],
};
</script>
